import React  from 'react'

import ColorComponentProto from "./color-proto"

export default function renderBooleanInEdit(id, props) {
    return <ColorComponentProto renderMode="edit" id={id} {...props}/>
}